import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);


// 首页
const home = r => require.ensure([], () => r(require('../pages/home/home')), 'home');


//测试页面
const test = r => require.ensure([], () => r(require('../pages/home/test')), 'test');


export default new Router({
    linkActiveClass: 'active',
    linkExactActiveClass: 'active',
    //mode: 'history',  //去除#
   // base: '/dist/',        //这个配置也很重要，否则会出现页面空白情况
    routes: [
        {
            path: '/',
            name: 'home',
            component: home,
            meta: { showAnimation: true, title:'首页' },
        },
        {
            path:'/home',
            name:'home',
            component:home,
            meta:{
                showAnimation: true,title:'首页'
            }
        },


    ]
});





// WEBPACK FOOTER //
// ./src/router/index.js